module.exports = __webpack_public_path__ + "static/media/1.6e381945.jpg";